import FilterMenu from "./FilterMenu";

const TimeFilter = ({
  filterName,
  fieldName,
  options,
  appliedFilters,
  setAppliedFilters,
  filterLogic,
  setFilterLogic,
  ...props
}) => {
  return (
    <FilterMenu
      filterName={filterName}
      fieldName={fieldName}
      options={options}
      appliedFilters={appliedFilters}
      setAppliedFilters={setAppliedFilters}
      timeControl
      singleSelect
      setFilterLogic={setFilterLogic}
      filterLogic={filterLogic}
      {...props}
    />
  );
};

export default TimeFilter;
